import React, { useState, useEffect, useRef } from "react";
import Header from "../Section/Header";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Search, Clock, Edit3 } from "lucide-react";
import Footer from "../Section/Footer";
import { useNavigate } from "react-router-dom";
import {
  create_Matchmaking,
  server_post_data,
  delete_for_android,
  view_subjecsts,
  match,
} from "../../ServiceConnection/serviceconnection";
import { formatDOB } from "../../CommonJquery/CommonJquery";
import { Modal, Button } from "react-bootstrap";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import FinalPayment from "./FinalPayment";
import SearchListData from "../Section/SearchListData";
export default function KundaliMatching({ page_name }) {
  const timeInputRefBoy = useRef(null);
  const timeInputRefGirl = useRef(null);
  const placeInputRefBoy = useRef(null);
  const placeInputRefGirl = useRef(null);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("match");
  const [showModal, setshowModal] = useState(false);
  const [boyData, setBoyData] = useState({
    name: "",
    gender: "male",
    dob: null,
    time: "",
    place: "",
    latitude: "",
    longitude: "",
  });
  const [girlData, setGirlData] = useState({
    name: "",
    gender: "female",
    dob: null,
    time: "",
    place: "",
    latitude: "",
    longitude: "",
  });
  const [saveKundali, setSaveKundali] = useState(true);
  const [errors, setErrors] = useState({ boy: {}, girl: {} });
  const [showSummary, setShowSummary] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //:-------------------------Saved Kundali Data------------------------------

  const [topicList, setTopicList] = useState([]);
  const [SavedRecentData, setSavedRecentData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredTopicList, setFilteredTopicList] = useState(topicList);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedKundaliId, setSelectedKundaliId] = useState(null);
  //--------------Guna Data------------------------
  const [kundlidata, setkundlidata] = useState([]);
  const [ShowStep2, setShowStep2] = useState(false);
  const [FinalDataPass, setFinalDataPass] = useState(null);
  //:------------------------All Kundali Data------------------------------
  const [editingGender, setEditingGender] = useState(""); 
    const [topicList2, setTopicList2] = useState([]);
    const [filteredTopicList2, setFilteredTopicList2] = useState(topicList2);
  useEffect(() => {
  if (!searchText.trim()) {
    setFilteredTopicList(topicList);
    setFilteredTopicList2(topicList2);
    return;
  }

  const regex = new RegExp(searchText, "i");

  // Full search for topicList
  const filteredList = topicList.filter(
    (item) =>
      (item.male_name && regex.test(item.male_name)) ||
      (item.female_name && regex.test(item.female_name)) ||
      (item.female_city_name && regex.test(item.female_city_name)) ||
      (item.male_city_name && regex.test(item.male_city_name))
  );

  // Only user_name search for topicList2
  const filteredList2 = topicList2
    .filter(
      (item) =>
        item.user_name &&
        item.user_name.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => (a.user_name || "").localeCompare(b.user_name || ""));

  setFilteredTopicList(filteredList);
  setFilteredTopicList2(filteredList2);
}, [searchText, topicList, topicList2]);


  const validate = () => {
    const boyErrors = {};
    const girlErrors = {};

    if (!boyData.name.trim()) boyErrors.name = "Enter boy's name.";
    if (!boyData.dob) boyErrors.dob = "Enter boy's birth date.";
    if (!boyData.time) boyErrors.time = "Enter boy's birth time.";
    if (!boyData.place.trim()) boyErrors.place = "Enter boy's birth place.";

    if (!girlData.name.trim()) girlErrors.name = "Enter girl's name.";
    if (!girlData.dob) girlErrors.dob = "Enter girl's birth date.";
    if (!girlData.time) girlErrors.time = "Enter girl's birth time.";
    if (!girlData.place.trim()) girlErrors.place = "Enter girl's birth place.";

    setErrors({ boy: boyErrors, girl: girlErrors });
    return (
      Object.keys(boyErrors).length === 0 &&
      Object.keys(girlErrors).length === 0
    );
  };
  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.warn("Google Maps JS not loaded");
      return;
    }

    const setupAutocomplete = (ref, setDataFn, label) => {
      if (!ref.current) {
        console.warn(`${label} ref not ready`);
        return null;
      }

      const autocomplete = new window.google.maps.places.Autocomplete(
        ref.current,
        {
          types: ["(cities)"],
          componentRestrictions: { country: "in" },
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const formatted = place.formatted_address || place.name || "";

        const lat = place.geometry?.location?.lat();
        const lng = place.geometry?.location?.lng();

        if (lat !== undefined && lng !== undefined) {
          setDataFn((prev) => ({
            ...prev,
            place: formatted,
            latitude: lat.toFixed(6),
            longitude: lng.toFixed(6),
          }));
        } else {
          console.warn(`Location data missing for ${label}`);
        }
      });

      return autocomplete;
    };

    const autoBoy = setupAutocomplete(placeInputRefBoy, setBoyData, "Boy");
    const autoGirl = setupAutocomplete(placeInputRefGirl, setGirlData, "Girl");

    return () => {
      if (autoBoy) window.google.maps.event.clearInstanceListeners(autoBoy);
      if (autoGirl) window.google.maps.event.clearInstanceListeners(autoGirl);
    };
  }, []);

  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };

    const parts = placeString.split(",").map((part) => part.trim());

    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };
  const handleDynamic = async (type) => {
    setIsLoading(true);
    const boyPlace = splitPlace(boyData.place);
    const girlPlace = splitPlace(girlData.place);
    //------Boy Data
    const dobDate = new Date(boyData.dob);
    const dobYear = dobDate.getFullYear();
    const dobMonth = String(dobDate.getMonth() + 1).padStart(2, "0");
    const dobDay = String(dobDate.getDate()).padStart(2, "0");
    //------Girl Data
    const dobDate2 = new Date(girlData.dob);
    const dobYear2 = dobDate.getFullYear();
    const dobMonth2 = String(dobDate2.getMonth() + 1).padStart(2, "0");
    const dobDay2 = String(dobDate2.getDate()).padStart(2, "0");
    const fd = new FormData();
    //-----boy Data
    fd.append("male_name", boyData.name);
    fd.append("male_dob", `${dobYear}-${dobMonth}-${dobDay}`);
    fd.append("male_dobtime", boyData.time);
    fd.append("male_city_name", boyPlace.city);
    fd.append("male_state_name", boyPlace.state);
    fd.append("male_contry_name", boyPlace.country);
    fd.append("male_latitude_data", boyData.latitude);
    fd.append("male_longitude_data", boyData.longitude);
    //-----Girl  Data
    fd.append("female_name", girlData.name);
    fd.append("female_dob", `${dobYear2}-${dobMonth2}-${dobDay2}`);
    fd.append("female_dobtime", girlData.time);
    fd.append("female_city_name", girlPlace.city);
    fd.append("female_state_name", girlPlace.state);
    fd.append("female_contry_name", girlPlace.country);
    fd.append("female_latitude_data", girlData.latitude);
    fd.append("female_longitude_data", girlData.longitude);
    await server_post_data(create_Matchmaking, fd)
      .then((Response) => {
        setIsLoading(false);
        setBoyData({
          name: "",
          gender: "male",
          dob: null,
          time: "",
          place: "",
        });

        setGirlData({
          name: "",
          gender: "female",
          dob: null,
          time: "",
          place: "",
        });
      //  masterDataGet();
        setShowSummary(true);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    masterDataGet();
    masterDataGet_Kuldi_data();
  }, []);
  const masterDataGet = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("flag", 8);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setTopicList(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));

        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const masterDataGet_Kuldi_data = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("flag", 7);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setTopicList2(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));
          setSavedRecentData(
            JSON.parse(JSON.parse(data[1])[0]["get_data_subs"])[0]
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleMatch = (e) => {
    e.preventDefault();
    if (validate()) {
      if (saveKundali) {
        handleDynamic();
      }
    }
  };

  const openTimePicker = (type) => {
    if (type === "Boy" && timeInputRefBoy.current) {
      timeInputRefBoy.current.showPicker();
    } else if (type === "Girl" && timeInputRefGirl.current) {
      timeInputRefGirl.current.showPicker();
    }
  };
  const handleShowDltModal = (kundaliId) => {
    setSelectedKundaliId(kundaliId);
    setShowDeleteModal(true);
    setshowModal(false);
  };
  const deletedata = async (flag_for) => {
    const form_data = new FormData();
    form_data.append("delete_idd", selectedKundaliId);
    form_data.append("flag_for", 2);
    setIsLoading(true);
    await server_post_data(delete_for_android, form_data)
      .then((Response) => {
        masterDataGet();
        setShowDeleteModal(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const parseDoshaString = (str) => {
    const keyValuePairs = str.replace(/{|}/g, "").split(", ");
    const obj = {};

    // Split each pair by '=' and add them to the object
    keyValuePairs.forEach((pair) => {
      const [key, value] = pair.split("="); // Split by '='
      obj[key] = parseFloat(value); // Convert the value to a number
    });

    return obj;
  };

  //----------------Matching Guna Data
  const masterGunaDataGet = async (matchdata) => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("male_name", matchdata.male_name);
    fd.append("male_dob", matchdata.male_dob);
    fd.append("male_dob_make", true);
    fd.append("male_dobtime", matchdata.male_dobtime);
    fd.append("male_city_name", matchdata.male_city_name);
    fd.append("male_state_name", matchdata.male_state_name);
    fd.append("male_country_name", matchdata.male_contry_name);
    fd.append("male_latitude_data", matchdata.male_latitude_data);
    fd.append("male_longitude_data", matchdata.male_longitude_data);

    fd.append("female_name", matchdata.female_name);
    fd.append("female_dob", matchdata.female_dob);
    fd.append("female_dob_make", true);
    fd.append("female_dobtime", matchdata.female_dobtime);
    fd.append("female_city_name", matchdata.female_city_name);
    fd.append("female_state_name", matchdata.female_state_name);
    fd.append("female_country_name", matchdata.female_contry_name);
    fd.append("female_latitude_data", matchdata.female_latitude_data);
    fd.append("female_longitude_data", matchdata.female_longitude_data);
    fd.append("male_dobtime2", matchdata.male_dobtime);
    fd.append("female_dobtime2", matchdata.female_dobtime);

    await server_post_data(match, fd)
      .then((Response) => {
        setIsLoading(false);
        setkundlidata(Response.Matching_data);
      })

      .catch((error) => {
        setIsLoading(false);
        console.log("this is error", error);
      });
  };
  const handleNavigate = (id, id2) => {
    navigate(`/kundli-matching/kundli-details/${id}/${id2}`);
  };
  const handleViewKundali = (match) => {
    setActiveTab("match");
    setSavedRecentData(match);
    setShowSummary(true);
    masterGunaDataGet(match);
  };

  const formattedLatLong = (originalValue) => {
    const multipliedValue = originalValue * 100;
    const roundedValue = Math.floor(multipliedValue);
    return roundedValue / 100;
  };

  const handleNavigatePayment = () => {
    const fd = new FormData();
    fd.append("male_name", SavedRecentData.male_name);
    fd.append("male_dob", SavedRecentData.male_dob);
    fd.append("male_dobtime", SavedRecentData.male_dobtime);
    fd.append("male_city_name", SavedRecentData.male_city_name);
    fd.append("male_state_name", SavedRecentData.male_state_name);
    fd.append("male_country_name", SavedRecentData.male_country_name);
    fd.append(
      "male_latitude_data",
      formattedLatLong(SavedRecentData.male_latitude_data)
    );
    fd.append(
      "male_longitude_data",
      formattedLatLong(SavedRecentData.male_longitude_data)
    );
    fd.append("user_gender", "Male");
    fd.append("male_time_zone_id", SavedRecentData.male_time_zone_id);
    fd.append("question_1", "");
    fd.append("female_name", SavedRecentData.female_name);
    fd.append("female_dob", SavedRecentData.female_dob);
    fd.append("female_dobtime", SavedRecentData.female_dobtime);
    fd.append("female_city_name", SavedRecentData.female_city_name);
    fd.append("female_state_name", SavedRecentData.female_state_name);
    fd.append("female_country_name", SavedRecentData.female_country_name);
    fd.append("female_latitude_data", SavedRecentData.female_latitude_data);
    fd.append("female_longitude_data", SavedRecentData.female_longitude_data);
    fd.append("female_time_zone_id", SavedRecentData.female_time_zone_id);
    fd.append("astrology_id", "0");
    fd.append("thread_id", "0");
    fd.append("astrology_name", "");

    fd.append("category_name", page_name);
    setFinalDataPass(fd);
    setShowStep2(true);
  };

const handleShowSaveSearchModl = (gender) => {
  console.log("Modal opened for:", gender);
  setEditingGender(gender);
  setshowModal(true);
  masterDataGet_Kuldi_data();
};
const formatTimeForInput = (timeString) => {
  if (!timeString) return "";

  // If it's already in HH:MM format, return as is
  if (/^\d{2}:\d{2}$/.test(timeString)) {
    return timeString;
  }

  // If it's in HH:MM:SS format, remove seconds
  if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
    return timeString.substring(0, 5);
  }

  // If it's in 12-hour format (like "02:30 PM"), convert to 24-hour
  if (timeString.includes("AM") || timeString.includes("PM")) {
    const [time, period] = timeString.split(" ");
    const [hours, minutes] = time.split(":");
    let hour24 = parseInt(hours);

    if (period === "PM" && hour24 !== 12) {
      hour24 += 12;
    } else if (period === "AM" && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, "0")}:${minutes}`;
  }

  return timeString;
};

const handleEditKundali = (kundali) => {
  console.log("✏️ Editing Kundali:", kundali);

  // Ensure DOB is converted to dayjs
  const dobParts = kundali.user_dob.split("-");
  const dobDate = dayjs(new Date(dobParts[0], dobParts[1] - 1, dobParts[2]));

  const placeString = `${kundali.city_name}, ${kundali.state_name}, ${kundali.country_name}`;
  const formattedTime = formatTimeForInput(kundali.user_dobtime2);

  const formObj = {
    name: kundali.user_name || "",
    gender: kundali.user_gender || "",
    dob: dobDate, // ✅ This must be dayjs()
    time: formattedTime,
    place: placeString,
    language: "english",
    saveKundali: true,
    latitude: kundali.latitude_data || "",
    longitude: kundali.longitude_data || "",
  };

  if (editingGender === "male") {
    setBoyData(formObj);
  } else if (editingGender === "female") {
    setGirlData(formObj);
  }

  setshowModal(false);
};


  const handleClose = () => {
    setshowModal(false);
  };
  return (
    <>
      <Header />
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow py-10 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8 ">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              💘 Kundli Matching
            </h2>
            <p className="text-lg text-purple-300">
              Enter both profiles to match kundalis
            </p>
          </div>
          {!showSummary && !ShowStep2 && (
            <div className="flex justify-center gap-9 border-b border-white/20 mb-6">
              <button
                onClick={() => {
                  setActiveTab("match");
                  setShowSummary(false);
                }}
                className={`pb-2 text-base font-medium ${
                  activeTab === "match"
                    ? "text-white border-b-2 border-pink-500"
                    : "text-purple-300"
                }`}
              >
                💮 Match Kundli
              </button>
              <button
                onClick={() => setActiveTab("saved")}
                className={`pb-2 text-base font-medium relative ${
                  activeTab === "saved"
                    ? "text-white border-b-2 border-pink-500"
                    : "text-purple-300"
                }`}
              >
                📋 Saved Matches
                {topicList.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                    {topicList.length}
                  </span>
                )}
              </button>
            </div>
          )}
          {activeTab === "match" && !showSummary && (
            <form
              id="kundali-form"
              onSubmit={handleMatch}
              className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-800/50 border border-purple-500/30 rounded-lg p-6 relative"
            >
              {[
                {
                  title: "Boy",
                  data: boyData,
                  setData: setBoyData,
                  ref: timeInputRefBoy,
                  err: errors.boy,
                },
                {
                  title: "Girl",
                  data: girlData,
                  setData: setGirlData,
                  ref: timeInputRefGirl,
                  err: errors.girl,
                },
              ].map(({ title, data, setData, ref, err }, idx) => (
                <div key={title} className="space-y-4   px-2 relative">
                  <h3 className="text-xl text-purple-100 font-semibold text-center">
                    {title}'s Details
                  </h3>
                  <div>
                    <label className="text-purple-200 text-sm">Full Name</label>
                    <div className="flex items-center justify-between h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border">
                      <input
                        type="text"
                        id="name"
                        placeholder="Enter your full name"
                        className="custum_input"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={data.name}
                        onChange={(e) =>
                          setData({ ...data, name: e.target.value })
                        }
                      />
                      <button
                        type="button"
                        aria-label="Search"
                     onClick={() => handleShowSaveSearchModl(title === "Boy" ? "male" : "female")}
                      >
                        <Search
                          color="#c0a0e7"
                          className="mr-[-6px]"
                          size={20}
                        />
                      </button>
                    </div>

                    {err.name && (
                      <span className="text-red-400 text-sm">{err.name}</span>
                    )}
                  </div>
                  {/* Date of Birth */}
                  <div className="space-y-1 cusm_date_picker_container">
                    <label
                      htmlFor="dob"
                      className="text-sm font-medium text-purple-200"
                    >
                      Date of Birth <span className="text-red-400">*</span>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.dob}
                        onChange={(date) => setData({ ...data, dob: date })}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "Select your birth date",
                            variant: "outlined",
                            className: "custom-datepicker",
                          },
                        }}
                      />
                    </LocalizationProvider>

                    {err.dob && (
                      <span className="text-red-400 text-sm error_SPAN">
                        {err.dob}
                      </span>
                    )}
                  </div>

                  {/* <div className="space-y-1">
                    <label className="text-sm font-medium text-purple-200">
                      Date of Birth *
                    </label>
                    <div className="relative date_picker_kundalii">
                      <DatePicker
                        selected={data.dob}
                        onChange={(date) => setData({ ...data, dob: date })}
                        maxDate={new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select your birth date"
                        className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                      />
                      <Calendar
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                      />
                    </div>
                    {err.dob && (
                      <span className="text-red-400 text-sm">{err.dob}</span>
                    )}
                  </div> */}
                  <div
                    className="space-y-1 timeofBirth"
                    onClick={() => openTimePicker(title)}
                  >
                    <label className="text-sm font-medium text-purple-200">
                      Time of Birth *
                    </label>
                    <div className="relative">
                      <input
                        type="time"
                        ref={ref}
                        className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={data.time}
                        onChange={(e) =>
                          setData({ ...data, time: e.target.value })
                        }
                      />
                      <Clock
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                      />
                    </div>
                    {err.time && (
                      <span className="text-red-400 text-sm">{err.time}</span>
                    )}
                  </div>
                  <div>
                    <label className="text-purple-200 text-sm">
                      Place of Birth
                    </label>
                    <input
                      autoComplete="off"
                      ref={
                        title === "Boy" ? placeInputRefBoy : placeInputRefGirl
                      }
                      type="text"
                      value={data.place}
                      onChange={(e) =>
                        setData({ ...data, place: e.target.value })
                      }
                      className="w-full bg-slate-700/50 px-3 py-2 rounded border border-purple-500/20 text-white"
                      placeholder="City, State, Country"
                    />
                    {err.place && (
                      <span className="text-red-400 text-sm">{err.place}</span>
                    )}
                  </div>
                  {data.latitude?.length > 0 && data.longitude?.length > 0 && (
                    <div className="flex items-center gap-4">
                      <div className="text-[12px] font-medium text-purple-200">
                        Latitude: {data.latitude}
                      </div>
                      <div className="text-[12px] font-medium text-purple-200">
                        Longitude: {data.longitude}
                      </div>
                    </div>
                  )}

                  {/* Divider after first column */}
                  {idx === 0 && (
                    <div className="hidden md:block absolute right-[-12px] top-[15px] bottom-[-16px] w-[1.5px] bg-white opacity-50" />
                  )}
                </div>
              ))}

              <div className="md:col-span-2 flex items-center gap-2 pl-2 pt-2">
                <input
                  type="checkbox"
                  className="h-[16px] w-[16px]"
                  checked={saveKundali}
                  onChange={(e) => setSaveKundali(e.target.checked)}
                />
                <label className="text-[var(--light-pink-color)] text-sm">
                  Save this matched Kundali
                </label>
              </div>
              <div className="md:col-span-2">
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-3 rounded-full font-semibold"
                >
                  🔮 Match Kundalis
                </button>
              </div>
            </form>
          )}
          {activeTab === "saved" && (
            <div className="space-y-4">
              <p className="text-[15px] text-[var(--light-pink-color)]">
                Recent Kundli
              </p>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-purple-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  type="text"
                  placeholder="Search saved matches..."
                  className="w-full pl-12 pr-4 py-3 bg-slate-800/50 border border-purple-500/30 rounded-xl text-purple-100 placeholder-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500/50 transition-all duration-300 hover:border-purple-400/50"
                />
              </div>
              <div className="space-y-4 max_height_clss">
                {filteredTopicList.length === 0 ? (
                  <div className="text-center text-purple-300 border border-purple-500/20 bg-slate-800/30 p-6 rounded-lg">
                    💕 <strong>No Saved Matches</strong>
                    <p className="mt-2">
                      Generate and save a matched kundali to see it here.
                    </p>
                  </div>
                ) : (
                  filteredTopicList.map((match, index) => (
                    <div
                      key={index}
                      className="rounded-lg border bg-slate-800/50 border-purple-500/30 p-6"
                    >
                      <div className="flex flex-col md:flex-row justify-between gap-6 relative">
                        {/* Boy Details */}
                        <div className="w-full md:w-1/2 pr-6">
                          <h4 className="text-purple-200 font-semibold mb-2">
                            Boy: {match?.male_name || "NA"}
                          </h4>
                          <p className="text-purple-300 text-sm">
                            DOB: {formatDOB(match.male_dob) || "NA"} | Time:{" "}
                            {match?.male_dobtime2 || "NA"}
                          </p>
                          <p className="text-purple-300 text-sm">
                            Place: {match?.male_city_name || "NA"}{" "}
                            {match?.male_state_name || "NA"}{" "}
                            {match?.male_country_name || "NA"}
                          </p>
                        </div>

                        {/* Divider */}
                        <div className="hidden md:block absolute left-1/2 top-[-6px] h-[130px] bottom-[-24px] w-[1.5px] bg-white opacity-50" />

                        {/* Girl Details */}
                        <div className="w-full md:w-1/2 pl-6">
                          <h4 className="text-pink-200 font-semibold mb-2">
                            Girl: {match?.female_name || "NA"}
                          </h4>
                          <p className="text-purple-300 text-sm">
                            DOB: {formatDOB(match.female_dob) || "NA"} | Time:{" "}
                            {match?.female_dobtime2 || "NA"}
                          </p>
                          <p className="text-purple-300 text-sm">
                            Place: {match?.female_city_name || "NA"}{" "}
                            {match?.female_state_name || "NA"}{" "}
                            {match?.female_country_name || "NA"}
                          </p>
                        </div>
                      </div>

                      {/* Saved Date and Button */}
                      <div className="mt-4 flex justify-between items-center">
                        <p className="text-purple-400 text-xs">
                          Saved on: {match?.actual_date || "NA"}
                        </p>
                        <div className="flex gap-2 items-center">
                          <button
                            onClick={() => handleViewKundali(match)}
                            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-4 py-2 rounded-full text-sm"
                          >
                            🔍 View
                          </button>
                          <button
                            onClick={() => handleEditKundali(match)}
                            className="flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white text-sm rounded-full transition-all"
                          >
                            <Edit3 size={14} />
                            Edit
                          </button>
                          <button
                            onClick={() => {
                              handleShowDltModal(match.mm_id);
                            }}
                            className="px-4 py-2 bg-red-600/20 hover:bg-red-600/40 text-red-400 text-sm rounded-full transition-all"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* Summary View */}
          {activeTab === "match" && showSummary && !ShowStep2 && (
            <div className="space-y-6 mt-3 relative">
              {/* Header with back + title */}
              <div className="flex py-2 justify-between items-center mb-8 lg:sticky lg:top-[68px] z-2 bg-transparent backdrop-blur-[5px] border-b border-white/20  ">
                <button
                  onClick={() => setShowSummary(false)}
                  className="py-2 px-[15px] rounded-md text-[var(--white)] border border-[var(--light-pink-color)] hover:bg-[var(--primary-hover-dark)]"
                >
                  ⬅️ Back
                </button>
                <p className="text-[var(--light-pink-color)] text-[26px] mb-2">
                  Guna Milan
                </p>
                <p style={{ opacity: "0" }}>placeholder</p>
              </div>

              <div className="flex flex-col lg:flex-row gap-2">
                {/* Left Side: Boy + Girl stacked vertically */}
                <div className="flex flex-col gap-6 w-full lg:w-[300px] shrink-0">
                  {/* Boy */}
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-purple-500/30 ">
                    <h3 className="text-xl text-center font-bold text-purple-200 mb-3">
                      Boy's Details
                    </h3>
                    <div className="flex justify-between items-center">
                      <div className="flex flex-col">
                        <p className="text-purple-300 text-sm mb-1">
                          Name: {SavedRecentData.male_name}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          DOB: {formatDOB(SavedRecentData.male_dob)}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          Time: {SavedRecentData.male_dobtime2}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          Place: {SavedRecentData.male_city_name}{" "}
                          {SavedRecentData.male_state_name}{" "}
                          {SavedRecentData.male_country_name}
                        </p>
                      </div>
                      <button
                        onClick={() =>
                          handleNavigate(SavedRecentData.mm_id, "Male")
                        }
                        className=" inline-block bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-3 py-2 rounded-full text-[12px]"
                      >
                        View Kundali
                      </button>
                    </div>
                  </div>
                  {/* Girl */}
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-purple-500/30 ">
                    <h3 className="text-xl text-center font-bold text-purple-200 mb-3">
                      Girls's Details
                    </h3>
                    <div className="flex justify-between items-center">
                      <div className="flex flex-col">
                        <p className="text-purple-300 text-sm mb-1">
                          Name: {SavedRecentData.female_name}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          DOB: {formatDOB(SavedRecentData.female_dob_make)}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          Time: {SavedRecentData.female_dobtime2}
                        </p>
                        <p className="text-purple-300 text-sm mb-1">
                          Place: {SavedRecentData.female_city_name}{" "}
                          {SavedRecentData.female_state_name}{" "}
                          {SavedRecentData.female_country_name}
                        </p>
                      </div>
                      <button
                        onClick={() =>
                          handleNavigate(SavedRecentData.mm_id, "Female")
                        }
                        className=" inline-block bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-3 py-2 rounded-full text-[12px]"
                      >
                        View Kundali
                      </button>
                    </div>
                  </div>
                  <Button
                    variant="warning"
                    className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] hover:text-[var(--light-pink-color)] border-none text-[var(--light-pink-color)] font-semibold text-[15px] px-4 py-2 rounded float-right mb-0"
                    onClick={handleNavigatePayment}
                  >
                    Need Consultation ?
                  </Button>
                </div>

                {/* Right Side: Table */}
                <div className="flex-1 overflow-x-auto border border-purple-500/20 rounded-lg bg-slate-800/40">
                  <table className="min-w-full text-left text-purple-100 border border-purple-500/30 rounded-lg overflow-hidden">
                    <thead className="bg-purple-900/60 text-purple-300 text-sm">
                      <tr className="border-b border-purple-500/20">
                        <th className="px-4 py-3 border-r border-purple-500/20">
                          Guna
                        </th>
                        <th className="px-4 py-3 border-r border-purple-500/20">
                          Obtained
                        </th>
                        <th className="px-4 py-3">Maximum</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm">
                      {kundlidata &&
                        kundlidata.map((item, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0
                                ? "bg-slate-800/40"
                                : "bg-slate-800/20"
                            } hover:bg-purple-900/30 border-b border-purple-500/10`}
                          >
                            <td className="px-4 py-3 border-r border-purple-500/10">
                              {item.name_Guna}
                            </td>
                            <td className="px-4 py-3 border-r border-purple-500/10">
                              {item.obtained_Guna}
                            </td>
                            <td className="px-4 py-3">{item.maximum_Guna}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          {ShowStep2 && (
            <FinalPayment FinalDataPass={FinalDataPass} Page_Name={page_name} />
          )}
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-dark">
            Are you sure you want to delete this Kundali?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cencelmodalCustmclss text-[15px] py-[9px] px-5"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] text-[15px] border-none py-[9px] px-5"
            variant="danger"
            onClick={deletedata}
          >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <SearchListData
        showModal={showModal}
        handleClose={handleClose}
        searchText={searchText}
        setSearchText={setSearchText}
        filteredTopicList={filteredTopicList2}
        handleEditKundali={handleEditKundali}
        handleShowDltModal={handleShowDltModal}
      />
      <Footer />
    </>
  );
}
